import React from 'react';
import { Appointments } from '../../../features/admin/Appointments/Appointments';

const AppointmentsPage = () => {
  return <Appointments />;
};

export default AppointmentsPage;
